<div class="d-flex flex-column h-100" [caLocalizationScope]="localizationScope">
  <div class="heading-20 mb-2">{{ 'reportLayout' | caLocalize }}</div>
  <f-single-choice-chip-group
    [items]="(layoutOptions$ | async)!"
    [selectedId]="layout"
    [chipSize]="chipSize"
    (select)="setLayout($event)"
    class="mb-2"
  ></f-single-choice-chip-group>
  @if (layout === ProfileReportLayout.Configurable) {
  <ca-configurable-templates
    [profileType]="request!.profileType"
    [request]="request"
    [setAsDefaultControl]="setAsDefaultControl"
    class="h-100"
  ></ca-configurable-templates>
  } @else {
  <div class="heading-20 mb-2 mt-5">{{ 'sections' | caLocalize }}</div>
  <p class="mb-2">{{ request!.profileType + 'ReportDescription' | caLocalize }}</p>
  <form [formGroup]="form">
    <ca-sections-selector formControlName="sections" (settingsChange)="settingsChange($event)"></ca-sections-selector>
    <ca-set-as-default-toggle
      [control]="setAsDefaultControl"
      [disableSaving]="disableSaving"
      [toggleLabel]="request!.profileType + 'ExtendedToggleLabel'"
    ></ca-set-as-default-toggle>
  </form>
  }

  <ng-template fDrawerFooterTemplate>
    @let isConfigurable = layout === ProfileReportLayout.Configurable;
    <ca-modify-report-drawer-footer
      [isConfigurable]="isConfigurable"
      [disableSaving]="disableSaving"
      [createReportTitle]="isConfigurable ? 'create' : request!.profileType + 'CreateReport'"
      [templateId]="selectedTemplateId"
      (closeDrawer)="close()"
      (createReport)="createReport()"
      (previewAndCustomize)="previewAndCustomize()"
    >
    </ca-modify-report-drawer-footer>
  </ng-template>
</div>
